import { useImperativeHandle, useRef, useEffect } from 'react';
export * from './useColor';
export * from './useTypography';
export * from './useDetectColorScheme';
export * from './usePatchedFocusRing';
export function useForwardedRef(forwardedRef) {
    const ref = useRef(null);
    useImperativeHandle(forwardedRef, () => ref.current);
    return ref;
}
export function usePressMessage({ onPress, onClick, }) {
    useEffect(() => {
        if (onPress)
            return;
        if (!onClick)
            return;
        console.warn('Use onPress instead of onClick');
    }, []);
}
